import { createSlice } from '@reduxjs/toolkit';

import CurrentUser from '@scripts/utilities/current-user.js';


const userSlice = createSlice({
    name: 'user',
    initialState: CurrentUser,
    reducers: {}
});


/**
 * helper function for retrieving the user from the store
 */
export function getUser(state) {
  return state.user;
}


export default userSlice.reducer;

